import { useContext } from "react";
import TreeStructureContext from "./TreeStructureContext";
import type { TreeStructureContextType } from "./types";

export default function useTreeStructure(): TreeStructureContextType {
	return useContext(TreeStructureContext);
}
